<template>
  <div>
    <b-carousel id="carousel-1" fade :interval="15000" indicators>
      <b-carousel-slide
        class="image-fluid"
        :key="lista.id"
        v-for="lista in lista"
      >
        <template v-slot:img>
          <img :src="lista.imglink" alt="image slot" />
        </template>
        <h1>{{ lista.rubrik }}</h1>
        <p>{{ lista.text }}</p>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slidercomponent",
  props: ["lista"]
};
</script>
